import { create } from 'zustand';

// eslint-disable-next-line import/prefer-default-export
export const useSentEmailListingStore = create(setState => ({
  page: 1,
  limit: 10,
  receiver: '',
  sender: '',
  startDate: null,
  endDate: null,
  selectedTemplates: [],
  emailId: '',
  setEmailId: emailId => setState({ emailId }),
  setReceiver: receiver => setState({ receiver }),
  setSender: sender => setState({ sender }),
  setStartDate: startDate => setState({ startDate }),
  setEndDate: endDate => setState({ endDate }),
  setSelectedTemplates: selectedTemplates => setState({ selectedTemplates }),
  setPage: page => setState({ page }),
  setLimit: limit => setState({ limit }),
}));
